import { Tooltip } from '@material-ui/core';
import { DriverTransferReservationsWithPricesAndResume } from '../models/DriverTransferReservationsWithSettlementInfo';

type ResumenProps = {
  resumen: DriverTransferReservationsWithPricesAndResume['resumen'];
};

const TD = (props: { children: React.ReactNode; className?: string }) => (
  <p className={'p-2 pr-8 text-sm ' + (props.className ?? '')}>
    {props.children}
  </p>
);

export const ResumenPreciosViajesComponent = ({ resumen }: ResumenProps) => {
  return (
    <div className="mb-8 w-full rounded-md border-2 border-gray-100 bg-white p-4 sm:border-0">
      <div className="flex justify-between">
        <TD>Cuenta corriente</TD>
        <TD>${resumen.total_current_account}</TD>
      </div>
      <div className="flex justify-between border-b-2 border-dashed border-gray-100">
        <TD>Efectivo</TD>
        <TD>${resumen.total_cash}</TD>
      </div>
      <div className="flex justify-between">
        <TD>Total trabajado</TD>
        <TD>${resumen.total_worked}</TD>
      </div>
      <div className="flex justify-between">
        <TD>Gastos</TD>
        <TD className="-mr-2">
          <div
            className="flex items-center justify-center h-full border-2 py-1 px-2 rounded-lg "
            style={{
              borderColor: '#f0f0f0',
              color: '#FF0000',
              background:
                'linear-gradient(to right, #FFFFFF, rgba(255, 0, 0, 0.04))'
            }}
          >
            ${resumen.total_expenses}
          </div>
        </TD>
      </div>
      <div className="flex justify-between border-b-2 border-dashed border-gray-100">
        <TD>Comision</TD>
        <TD>${resumen.commission}</TD>
      </div>
      <Tooltip title="Total trabajado - Comisión administrativa" arrow>
        <div className="flex justify-between">
          <TD>Cobra</TD>
          <TD>${resumen.total_worked - resumen.commission}</TD>
        </div>
      </Tooltip>
      <Tooltip title="Comisión administrativa" arrow>
        <div className="flex justify-between border-b-2 border-dashed border-gray-100">
          <TD>Paga</TD>
          <TD>${resumen.commission}</TD>
        </div>
      </Tooltip>

      <Tooltip
        title="Total cuenta corriente + Gastos - Comisión administrativa "
        arrow
      >
        <tr className="flex justify-between">
          <TD>
            <div
              style={{
                color: '#008711',
                background:
                  'linear-gradient(to right, #FFFFFF, rgba(0, 196, 17, 0.08))'
              }}
            >
              Saldo a favor del chofer
            </div>
          </TD>
          <TD className="-mr-2 -mt-1">
            <div
              className="flex items-center justify-center h-full border-2 py-1 px-2 rounded-lg "
              style={{
                borderColor: '#f0f0f0',
                color: '#008711',
                background:
                  'linear-gradient(to right, #FFFFFF, rgba(0, 196, 17, 0.05))'
              }}
            >
              ${resumen.total_billed}
            </div>
          </TD>
        </tr>
      </Tooltip>
    </div>
  );
};
